import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, Cpu, Layers, CheckCircle2 } from 'lucide-react';

const ServicesPage = () => {
  const { t } = useTranslation();

  // Guardamos las características controlando de forma segura si es un Array válido
  const featuresArray = t('services.main.features');
  const safeFeatures = Array.isArray(featuresArray) ? featuresArray : [];

  return (
    <div className="pt-28 pb-20 min-h-screen bg-slate-50 font-sans">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Cabecera de la Página */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight sm:text-5xl">
            {t('services.title')}
          </h1>
          <p className="mt-4 text-xl text-slate-600">
            {t('services.subtitle')}
          </p>
          <div className="mt-4 h-1 w-20 bg-primary mx-auto rounded-full"></div>
        </div>

        {/* Bloque Principal: Fabricación de Mazos y Cuadros */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden p-8 lg:p-12 mb-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-bold uppercase tracking-wider">
                <Cpu size={14} /> Producción Industrial
              </div>
              <h2 className="text-2xl lg:text-3xl font-bold text-slate-900">
                {t('services.main.title')}
              </h2>
              <p className="text-slate-600 leading-relaxed text-base">
                {t('services.main.description')}
              </p>

              {/* Listado de Características con renderizado seguro */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
                {safeFeatures.length > 0 ? (
                  safeFeatures.map((feature, index) => (
                    <div key={index} className="flex items-start gap-3 bg-slate-50 p-3 rounded-lg border border-slate-100">
                      <CheckCircle2 size={18} className="text-primary mt-0.5 flex-shrink-0" />
                      <span className="text-sm font-medium text-slate-700">{feature}</span>
                    </div>
                  ))
                ) : (
                  <p className="text-sm text-slate-400 italic col-span-2">Cargando características de fabricación...</p>
                )}
              </div>
            </div>

            {/* Ilustración o Bloque de Impacto Visual Lateral */}
            <div className="lg:col-span-5 bg-gradient-to-br from-slate-900 to-slate-800 rounded-xl p-8 text-white h-full flex flex-col justify-between shadow-inner min-h-[300px]">
              <div>
                <h3 className="text-xl font-bold text-white mb-2">Garantía Voltaris</h3>
                <p className="text-sm text-slate-300 leading-relaxed">
                  Todos nuestros procesos están orientados a cumplir rigurosos criterios de trazabilidad, seguridad y optimización de costes logísticos.
                </p>
              </div>
              <div className="pt-6 border-t border-slate-700 space-y-3">
                <div className="flex items-center gap-3 text-xs font-semibold text-slate-300">
                  <span className="w-2 h-2 rounded-full bg-green-400"></span> Alta Fiabilidad Coaxial y Eléctrica
                </div>
                <div className="flex items-center gap-3 text-xs font-semibold text-slate-300">
                  <span className="w-2 h-2 rounded-full bg-green-400"></span> Control de Crimpado Homologado
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Sección de Servicios Complementarios */}
        <div className="mt-16">
          <h3 className="text-xl font-bold text-slate-900 text-center mb-8 flex items-center justify-center gap-2">
            <Layers size={20} className="text-primary" /> {t('services.additional.title')}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            
            {/* Tarjeta: Soporte a Proyectos */}
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between">
              <div>
                <div className="w-10 h-10 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center font-bold text-lg mb-4">1</div>
                <h4 className="text-base font-bold text-slate-800 mb-2">{t('services.additional.items.support.title')}</h4>
                <p className="text-sm text-slate-600 leading-relaxed">{t('services.additional.items.support.description')}</p>
              </div>
            </div>

            {/* Tarjeta: Certificación y Calidad */}
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between">
              <div>
                <div className="w-10 h-10 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center font-bold text-lg mb-4">2</div>
                <h4 className="text-base font-bold text-slate-800 mb-2">{t('services.additional.items.certification.title')}</h4>
                <p className="text-sm text-slate-600 leading-relaxed">{t('services.additional.items.certification.description')}</p>
              </div>
            </div>

            {/* Tarjeta: Logística y Entrega */}
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between">
              <div>
                <div className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center font-bold text-lg mb-4">3</div>
                <h4 className="text-base font-bold text-slate-800 mb-2">{t('services.additional.items.logistics.title')}</h4>
                <p className="text-sm text-slate-600 leading-relaxed">{t('services.additional.items.logistics.description')}</p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default ServicesPage;